import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  baseUrl() {
    return `${window.api_url}/organization/family_subsidy_invitations/bulk_create`;
  },

  bulkCreate(invitations) {
    return axios
      .post(this.baseUrl(), {
        family_subsidy_invitations: invitations,
      })
      .catch(handleError);
  },
};
